export const useSnapChat = () => {
  const snapSend = eventName =>
    window.snaptr && window.snaptr('track', eventName)
  return { snapSend }
}
